"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSafeURLParameters = void 0;
const tslib_1 = require("tslib");
const xss_1 = (0, tslib_1.__importDefault)(require("xss"));
const regex_1 = require("../../constants/regex");
/**
 * Extract query parameters from a url in a safe manner, preventing xss attacks
 * @public
 *
 * @param url - An url to extract the parameters
 *
 * @returns The url safe parameters as a key-value dictionary.
 *
 * @example
 * ```ts
 * let parameters = getSafeURLParameters('?p.fname=fname&p.lname=lname')
 * console.log(parameters);
 * // -> {fname: 'fname',lname:'lname}
 * ```
 */
function getSafeURLParameters(url = window.location.search) {
    const result = {};
    url = url.trim().split('#')[0];
    if (url === '') {
        return result;
    }
    const parts = url.match(regex_1.DOMAIN_PARTS);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const queryString = parts[6];
    const searchParams = new URLSearchParams(queryString);
    // remove prefix from params
    for (const [key, value] of searchParams) {
        result[key.toLowerCase().replace('p.', '')] = (0, xss_1.default)(decodeURIComponent(value));
    }
    return result;
}
exports.getSafeURLParameters = getSafeURLParameters;
//# sourceMappingURL=get-safe-url-parameters.js.map